import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
 
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
interface AssistantRequest {
  conversationId?: string | null;
  message: string;
  context?: any;
}

@Injectable()
export class ApiService {
  
  getLookupGroups() {
    throw new Error('Method not implemented.');
  }
  getEmailTemplatePreview(templateId: any, fundId: any, investorId: any) {
    throw new Error('Method not implemented.');
  }
  get(InvestorAccountDetails_Get: string | undefined) {
    throw new Error('Method not implemented.');
  }

  loading: boolean = false;

  authService: any;
  isLoggedIn: boolean;

  constructor(public http: HttpClient, public router: Router,  private snackBar: MatSnackBar,private toastr: ToastrService) {}

  httpGet(url: string) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const token = sessionStorage.getItem('Token');
    if (token) {
      headers = headers.append('Authorization-Token', token);
    }

    return this.http.get(url, { headers: headers }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err) => {
        if (err.status === 401) {
          this.toastr.error('Your session has expired', 'Error 401');
          this.authService.logout();
        } else {
          this.toastr.error("Something's gone wrong", 'Error');
        }
        const error = err.error.message || err.statusText;
        return throwError(() => error);
      })
    );
  }
 
  

  httpPosst(url: string, body: any, options?: any): Observable<any> {
    return this.http.post(url, body, options);
  }

httpPost(url: string, body: any, options?: any) {
  let headers = options?.headers || new HttpHeaders();

  headers = headers.set('Content-Type', 'application/json');

  const token = sessionStorage.getItem('authToken');
  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  return this.http.post(url, body, {
    ...options,
    headers
  }).pipe(
    map((response: any) => response),
    catchError((err) => {
      if (err.status === 0) {
        this.logout();
      } else if (err.status === 500 && err.error?.referenceId) {
        const displayText = `Unexpected error | Ref ID: ${err.error.referenceId}`;
        this.toastr.error(displayText, 'System Error', { timeOut: 10000, closeButton: true });
      } else if (err.status === 400 && err.error?.value === 0) {
        this.toastr.error('Unexpected error occurred', 'Error', { timeOut: 10000, closeButton: true });
      }

      return throwError(() => err);
    })
  );
}

 

  fnDownalodVault(url: string, body: any) : Observable<any>{
    return this.http.post<any>(url,body,
      {
        headers: new HttpHeaders({
           "Content-Type": "application/json"
        })
      });
  }

  login() {
    this.authService.login().subscribe(() => {
      if (this.authService.isLoggedIn === true) {
        let redirect = this.authService.redirect ? this.authService.redirect : '/home';
        this.router.navigate([redirect]);
        this.authService.isLoggedIn = true;
      } else {
        this.authService.isLoggedIn = false;
      }
    });
  }
  logout(): void {
    this.toastr.error("Ops error");
  }
  getLatestHtml(): Observable<string> {
    return this.http.get('https://localhost:7138/api/Message/get-latest-html', {
      responseType: 'text'
    });
  }
  
  
    
    apiUrl4="https://localhost:7138/api/Message/save-html"
    saveHtmlData(content: string) {
      return this.http.post(this.apiUrl4, { htmlContent: content });
    }
     sendMessage(req: AssistantRequest): Observable<any> {
    return this.http.post('https://localhost:7017/api/CapitalCall/chat', req);
  }
}
